import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_CORGI_PERIMETERX_SENSOR_SCRIPT_ENABLED = createFcmConfig('corgi_perimeterx_sensor_script_enabled', {
	normalizer: normalizeBoolean,
	defaultValue: true, // enabled by default for security
});
